<template>
  <v-dialog v-if="isAdmin" v-model="showModal" @keydown.esc="checkModalOpened" max-width="500px" persistent>
    <v-btn slot="activator" @click.native="openModal" color="success" depressed dark>Novo range</v-btn>

    <v-card>
      <v-card-title>
        <span v-if="selectedItem.id" class="headline">Editar Range</span>
        <span v-else class="headline">Criar Range</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-flex xs12>
          <v-text-field
            type="number"
            min="0"
            v-model="selectedItem.order"
            label="Ordenação"/>
          <v-text-field
            v-model="selectedItem.title"
            label="Título"
            required/>
          <v-text-field
            v-model="selectedItem.description"
            label="Observação"/>
          <div class="pl-form-field">
            <v-text-field
              v-model="selectedItem.color"
              label="Cor"
              @click="toggleColorPicker"/>
            <v-btn
              fab
              flat
              small
              :color="selectedItem.color"
              @click.native="toggleColorPicker"
              class="pl-form-picker-btn">
                <v-icon dark>format_color_fill</v-icon>
            </v-btn>
          </div>

          <v-dialog v-model="showColorPicker" width="226">
            <chrome-picker :value="colors" @input="updateFromPicker"/>
          </v-dialog>
        </v-flex>
      </v-card-text>

      <v-card-actions>
        <v-btn color="grey" flat @click.native="toggleModal">Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" depressed @click.native="save">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { db } from '@/db'
import { mapGetters, mapActions } from 'vuex'
import { Chrome } from 'vue-color'

export default {
  name: 'RangeForm',

  components: {
    'chrome-picker': Chrome
  },

  computed: {
    ...mapGetters(['showModal', 'selectedItem']),
    ...mapGetters('auth', ['isAdmin']),
    ...mapGetters('courses', ['currentCourse'])
  },

  data () {
    return {
      range: {
        order: 0,
        title: '',
        description: '',
        color: ''
      },
      showColorPicker: false,
      colors: {
        hex: '#3ABC5B'
      },
      cores: [
        { text: 'Amarelo', value: 'yellow' },
        { text: 'Azul', value: 'blue' },
        { text: 'Ciano', value: 'cyan' },
        { text: 'Grama', value: 'gram' },
        { text: 'Gelo', value: 'ice' },
        { text: 'Limão', value: 'lime' },
        { text: 'Laranja', value: 'amber' },
        { text: 'Marrom', value: 'brown' },
        { text: 'Rosa', value: 'pink' },
        { text: 'Roxo', value: 'purple' },
        { text: 'Vermelho', value: 'red' },
        { text: 'Verde', value: 'green' }
      ]
    }
  },

  methods: {
    ...mapActions(['toggleModal', 'setSelectedItem']),
    ...mapActions('ranges', ['getRanges']),

    openModal () {
      this.setSelectedItem(this.range)
      this.toggleModal()
    },

    checkModalOpened () {
      if (this.showColorPicker) {
        this.showColorPicker = !this.showColorPicker
      } else {
        this.toggleModal()
      }
    },

    save () {
      let _this = this

      this.selectedItem.order = parseInt(this.selectedItem.order)

      if (this.selectedItem.id !== undefined) {
        const updatedAt = new Date()
        let currentDocRef = db.collection('ranges').doc(this.selectedItem.id)

        currentDocRef.set({
          ...this.selectedItem,
          updatedAt
        }).then(() => {
          _this.toggleModal()
        })
      } else {
        const createdAt = new Date()

        db.collection('ranges').add({
          ...this.selectedItem,
          courseId: this.currentCourse.id,
          filterId: this.$route.params.filterId,
          hands: [],
          createdAt
        }).then(() => {
          _this.toggleModal()
        })
      }

      this.range = {
        title: '',
        description: '',
        color: ''
      }
    },

    toggleColorPicker () {
      this.showColorPicker = !this.showColorPicker
    },

    updateFromPicker (color) {
      this.colors = color

      if (color.rgba.a === 1) {
        this.selectedItem.color = color.hex
      } else {
        this.selectedItem.color = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')'
      }
    }
  }
}
</script>
